import {
    GameId,
    ClassicGameDefinition,
    GameSettings,
    partnerSettingsStore,
    sessionStore,
    isForceMuted,
} from '@bg-shared';

export class GamesSettingsDefinition {
    private static BASE = [[GameSettings.VIDEO]];

    private static CHIPS_GAME = [
        [GameSettings.STUDIO_SOUND, GameSettings.GAME_SOUND],
        [GameSettings.VIDEO],
    ];

    private static SKYWARD = [
        [GameSettings.GAME_SOUND, GameSettings.MUSIC, GameSettings.ANIMATION],
        [GameSettings.CERTIFICATE, GameSettings.LIMITS],
    ];

    private static filterSettings(settings: GameSettings[][], gameId: GameId): GameSettings[][] {
        let filtered = settings;
        const remove = (value: GameSettings) =>
            filtered
                .map((group) => group.filter((setting) => setting !== value))
                .filter((group) => group.length);

        if (
            !partnerSettingsStore.isCasinoViewEnabled &&
            !partnerSettingsStore.isLithuaniaJurisdiction
        ) {
            filtered = remove(GameSettings.CASINO);

            if (ClassicGameDefinition.isCasinoView(gameId)) {
                filtered = remove(GameSettings.GAME_SOUND);
            }
        }

        if (sessionStore.onlyGUI || ClassicGameDefinition.isGui(gameId as number)) {
            filtered = remove(GameSettings.VIDEO);
            filtered = remove(GameSettings.STUDIO_SOUND);
        }

        if (isForceMuted(gameId)) {
            filtered = remove(GameSettings.STUDIO_SOUND);
        }

        return filtered;
    }

    public static getSettings(gameId: GameId): GameSettings[][] {
        let settings: GameSettings[][] = [];

        if (ClassicGameDefinition.isChipsGame(gameId)) {
            settings = [...this.CHIPS_GAME];
            if (ClassicGameDefinition.isCasinoView(gameId)) {
                settings.splice(1, 0, [GameSettings.CASINO]);
            }
        } else if (ClassicGameDefinition.isSkywardGame(gameId)) {
            settings = this.SKYWARD;
        } else {
            settings = this.BASE;
        }

        return this.filterSettings(settings, gameId);
    }
}
